<template>
  <div>
    <div v-show="showTitulo('Operação')" class="card-cenario-titulo">
      <b>Operação:</b>
    </div>
    <div class="card-cenario-corpo">
      <div v-show="cenario.id_local_operacao != false">
        {{ filterLabel("local", filtros.local.valores, cenario.id_local_operacao) }}
      </div>
      <div v-show="cenario.id_pais_origem != false">
        {{ filterLabel("pais_origem", filtros.pais_origem.valores, cenario.id_pais_origem) }}
      </div>
      <div v-show="cenario.id_estado_origem != false">
        {{ filterLabel("estado_origem", filtros.estado_origem.valores, cenario.id_estado_origem) }}
      </div>
      <div v-show="cenario.id_estado_destino != false">
        {{
          filterLabel("estado_destino", filtros.estado_destino.valores, cenario.id_estado_destino)
        }}
      </div>
      <div v-show="cenario.id_pais_destino != false">
        {{ filterLabel("pais_destino", filtros.pais_destino.valores, cenario.id_pais_destino) }}
      </div>
    </div>
    <div v-show="showTitulo('Remetente')" class="card-cenario-titulo"><b>Remetente:</b></div>
    <div class="card-cenario-corpo">
      <div v-show="cenario.id_remetente_regime != false">
        {{
          filterLabel(
            "regime_tributacao",
            filtros.regime_tributacao.valores,
            cenario.id_remetente_regime
          )
        }}
      </div>
      <div v-show="cenario.id_remetente_atividade != false">
        {{ filterLabel("atividade", filtros.atividade.valores, cenario.id_remetente_atividade) }}
      </div>
      <div v-show="cenario.id_remetente_tipo_atividade != false">
        {{
          filterLabel(
            "tipo_atividade",
            filtros.tipo_atividade.valores,
            cenario.id_remetente_tipo_atividade
          )
        }}
      </div>
    </div>
    <div v-show="showTitulo('Destinatário')" class="card-cenario-titulo">
      <b>Destinatário:</b>
    </div>
    <div class="card-cenario-corpo">
      <div v-show="cenario.id_destinatario_regime != false">
        {{
          filterLabel(
            "regime_tributacao",
            filtros.regime_tributacao.valores,
            cenario.id_destinatario_regime
          )
        }}
      </div>
      <div v-show="cenario.id_destinatario_atividade != false">
        {{ filterLabel("atividade", filtros.atividade.valores, cenario.id_destinatario_atividade) }}
      </div>
      <div v-show="cenario.id_destinatario_tipo_atividade != false">
        {{
          filterLabel(
            "tipo_atividade",
            filtros.tipo_atividade.valores,
            cenario.id_destinatario_tipo_atividade
          )
        }}
      </div>
    </div>
    <div v-show="showTitulo('Mercadoria')" class="card-cenario-titulo">
      <b>Mercadoria:</b>
    </div>
    <div class="card-cenario-corpo">
      <div v-show="cenario.id_origem != false">
        {{ filterLabel("origem_mercadoria", filtros.origem_mercadoria.valores, cenario.id_origem) }}
      </div>
      <div v-show="cenario.id_destinacao != false">
        {{ filterLabel("destinacao", filtros.destinacao.valores, cenario.id_destinacao) }}
      </div>
    </div>
  </div>
</template>

<script>
import cenariosMixin from "@/mixins/cenariosMixin";
import { mapGetters } from "vuex";
import filtros from "@/store/modules/cenarioFiltros.js";

export default {
  name: "CardCenario",
  mixins: [cenariosMixin],
  props: ["cenario"],
  data() {
    return {
      filtros
    };
  },
  computed: {
    ...mapGetters("cenario", ["getFiltros"])
  },
  methods: {
    showTitulo(titulo) {
      if (titulo == "Operação") {
        let check = [
          this.cenario.id_local_operacao,
          this.cenario.id_estado_origem,
          this.cenario.id_estado_destino,
          this.cenario.id_pais_origem,
          this.cenario.id_pais_destino
        ];
        if (check.filter(p => p == false).length == check.length) {
          return false;
        }
        return true;
      }
      if (titulo == "Remetente") {
        let check = [
          this.cenario.id_remetente_regime,
          this.cenario.id_remetente_atividade,
          this.cenario.id_remetente_tipo_atividade
        ];
        if (check.filter(p => p == false).length == check.length) {
          return false;
        }
        return true;
      }
      if (titulo == "Destinatário") {
        let check = [
          this.cenario.id_destinatario_regime,
          this.cenario.id_destinatario_atividade,
          this.cenario.id_destinatario_tipo_atividade
        ];
        if (check.filter(p => p == false).length == check.length) {
          return false;
        }
        return true;
      }
      if (titulo == "Mercadoria") {
        let check = [this.cenario.id_origem, this.cenario.id_destinacao];
        if (check.filter(p => p == false).length == check.length) {
          return false;
        }
        return true;
      }
    },
    filterLabel(key, filtros, code) {
      if (!code || code == 0) {
        return false;
      }
      // if (typeof filtros != "object") {
      //   return false;
      // }

      let filtro = filtros.find(f => f.value == code);

      if (!filtro) {
        return false;
      }
      return filtro.label;
    }
  }
};
</script>

<style>
.card-cenario-titulo {
  font-size: 11px;
  text-align: left;
  border-top: 1px solid var(--branco);
  padding-top: 2px;
}
.card-cenario-titulo:first-child {
  border-top: 0px solid var(--branco);
  padding-top: 0px;
  margin-top: -2px;
}
.card-cenario-corpo {
  font-size: 11px;
  text-align: left;
  margin-bottom: 3px;
}
</style>
